import { initElmApp } from 'elm/utilities'
import * as Feedback from 'elm/src/Feedback.elm'

export function init (): null {
  const app = initElmApp(Feedback)

  app.ports.takeScreenshot.subscribe((delay: number) => {
    setTimeout(() => {
      captureScreenshot(app)
    }, delay)
  })
}

async function captureScreenshot (app: any): void {
  try {
    const stream = await (navigator.mediaDevices as any).getDisplayMedia({ preferCurrentTab: true, selfBrowserSurface: 'include', surfaceSwitching: 'exclude' })
    const video = document.createElement('video')
    video.srcObject = stream

    video.onloadedmetadata = () => {
      void video.play()
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      context?.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)

      app.ports.screenshotTaken.send(canvas.toDataURL())
      stream.getTracks().forEach((track: MediaStreamTrack) => track.stop())
    }
  } catch (error) {
    console.error('Error capturing screenshot:', error)
    if (error.name === 'NotAllowedError' || error.name === 'SecurityError') {
      app.ports.permissionDenied.send()
    }
  }
}
